import {
  READ_ACTION,
  CUSTOMER_RESOURCE,
} from "@/constants/resources";
import { infoDashboard } from "@/helpers/modalInfo";

export default [
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import("@/modules/dashboard/views/Dashboard.vue"),
    meta: {
      resource: CUSTOMER_RESOURCE,
      action: READ_ACTION,
      pageTitle: "Dashboard",
      info: infoDashboard
    },
  }
];
